import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import moment from 'moment';
import { RootState } from '../../../core/store';
import { ModePage } from '../../../core/types/common/ConfigPageComponent';
import { ESyncLogsTabs } from '../../types';

export interface SettingsState {
    startDate: Date | undefined;
    endDate: Date | undefined;
    currentTab: ESyncLogsTabs;
    redirectLink: string;
    appLink: string;
    modePage: ModePage;
}

let currentDate = new Date();
let startDate = new Date(moment(currentDate).add(-5, 'days').toString());

const initialState: SettingsState = {
    startDate: startDate,
    endDate: undefined,
    currentTab: ESyncLogsTabs.logs,
    redirectLink: '/access-denied',
    appLink: '',
    modePage: ModePage.BaseComponent
};

const settingsSlice = createSlice({
    name: 'asiteRelaticsLogs/settings',
    initialState,
    reducers: {
        setStartDate(state, action: PayloadAction<Date | undefined>) {
            state.startDate = action.payload;
        },
        setEndDate(state, action: PayloadAction<Date | undefined>) {
            state.endDate = action.payload;
        },
        setCurrentTab(state, action: PayloadAction<ESyncLogsTabs>) {
            state.currentTab = action.payload;
        },
        setRedirectLink(state, action: PayloadAction<string>) {
            state.redirectLink = action.payload;
        },
        setAppLink(state, action: PayloadAction<string>) {
            state.appLink = action.payload;
        },
        setModePage(state, action: PayloadAction<ModePage>) {
            state.modePage = action.payload;
        }
    },
});

// Selectors
const getSettings = (state: RootState) => state.asiteRelaticsSyncLogs.settings;

const getStartDate = createSelector(getSettings, (settings) => settings.startDate);
const getEndDate = createSelector(getSettings, (settings) => settings.endDate);
const getCurrentTab = createSelector(getSettings, (settings) => settings.currentTab);
const getRedirectLink = createSelector(getSettings, (settings) => settings.redirectLink);
const getAppLink = createSelector(getSettings, (settings) => settings.appLink);
const getModePage = createSelector(getSettings, (settings) => settings.modePage);

// Export
export const settingsReducer = settingsSlice.reducer;
export const actions = { ...settingsSlice.actions };
export const selectors = { getSettings, getStartDate, getEndDate, getCurrentTab, getRedirectLink, getAppLink, getModePage };
